module.exports = __webpack_public_path__ + "static/media/gegenverkehr.cac26382.svg";